var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents" }, [
    _c(
      "div",
      { staticClass: "contents__contents contents__contents--result" },
      [
        _c("div", { staticClass: "contents__set" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "contents__card check-list" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("ul", { staticClass: "check-list__list" }, [
              this.proteinSelfCheckList.includes("Q9-1")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        탈모 고민\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfCheckList.includes("Q9-2")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        가늘어진 머리카락\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfCheckList.includes("Q9-3")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        거칠고 푸석한 피부\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfCheckList.includes("Q9-4")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        손발톱 갈라짐\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfCheckList.includes("Q9-5")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        근육량 감소\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfCheckList.includes("Q9-6")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        면역력 감소\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfCheckList.includes("Q9-7")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        혈액순환 장애\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfCheckList.includes("Q9-8")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        단 음식이 자주 먹고 싶음\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfCheckList.includes("Q9-9")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        피로감\n                    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.proteinSelfCheckList.includes("Q9-10")
                ? _c("li", { staticClass: "check-list__item" }, [
                    _c("i"),
                    _vm._v(
                      "\n                        근력 감소\n                    "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "contents__msg" }, [
            _vm._v(
              "위 증상들은 모두 단백질이 부족해질 때 우리 몸에서 보내는 신호들이에요."
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _vm._v("\n                내몸이 보내는"),
      _c("br"),
      _vm._v("\n                단백질 부족 신호\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "check-list__msg check-list__msg--danger" }, [
      _c("i"),
      _vm._v(" 위험해요! 단백질 꼭 챙겨드세요")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b699edc8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b699edc8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/component/myproteinSelfHighScore.vue
// module id = null
// module chunks = 